import type { ComponentProps } from "react";

import { cn } from "@synthesis/shared-utils";

export const NotificationBody = ({ className, children, ...props }: ComponentProps<"div">) => (
  <div
    className={cn(
      "before:bg-neutrals-60 relative flex items-center break-words pl-[22px] before:absolute before:left-[6px] before:top-0 before:h-full before:min-w-1 before:rounded before:content-['']",
      className,
    )}
    {...props}
  >
    {children}
  </div>
);
